import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { none, MyBookingScreen } from './myBookingScreen';

interface MyBookingState {
  viewModel: MyBookingScreen.ViewModel;
}

const initialState: MyBookingState = {
  viewModel: none(''),
};

export const myBookingSlice = createSlice({
  name: 'myBooking',
  initialState,
  reducers: {
    setViewModel: (state, action: PayloadAction<MyBookingScreen.ViewModel>) => {
      state.viewModel = action.payload;
    },
  },
});

export const { setViewModel } = myBookingSlice.actions;

export default myBookingSlice.reducer;
